// extracted by mini-css-extract-plugin
module.exports = {"popoverInner":"MenuPopover_popoverInner__1NLpb"};